module.exports = __webpack_public_path__ + "img/equipment.9e6d5738.svg";